import { useState } from "react";
import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import IconAsButton from "src/components/IconAsButton";
import { ReactComponent as AddIcon } from "src/icons/add-circle-outlined.svg";
import { ReactComponent as MoreIcon } from "src/icons/more-vert.svg";

export default function LullabiesListItemActionIcon({
  lullaby,
  onDelete,
  onEdit,
  onAdd,
  audioController
}) {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const status = audioController.getStatusForIdentifier(lullaby.objectId);

  if (
    status === audioController.Status.PLAYING ||
    status === audioController.Status.LOADING
  ) {
    return null;
  }
  if (onAdd) {
    return (
      <IconAsButton
        icon={AddIcon}
        onClick={onAdd}
        fill="mediumEmphasis"
        size="20px"
      />
    );
  }
  if (!onEdit && !onDelete) return null;
  return (
    <Menu
      isOpen={isMenuOpen}
      onOpen={(e) => {
        setIsMenuOpen(true);
      }}
      onClose={(e) => {
        setIsMenuOpen(false);
      }}
      elevationLevel={2}
      icon={MoreIcon}
      py="8px"
    >
      {onEdit && (
        <MenuItem onClick={onEdit}>
          <MenuItemText>{t("buttons.edit")}</MenuItemText>
        </MenuItem>
      )}
      {onDelete && (
        <MenuItem onClick={onDelete}>
          <MenuItemText>{t("buttons.delete")}</MenuItemText>
        </MenuItem>
      )}
    </Menu>
  );
}
